import { motion } from "framer-motion";
import { Store, GraduationCap, Cake, ArrowRight } from "lucide-react";

const EVENTS = [
  {
    type: "vendor",
    icon: Store,
    title: "Vendor Events",
    img: "/brand/vendor-booth.png",
    alt: "Happy customers at an indoor vendor booth with Sy Sy's Snacks nachos and lemonade",
    copy: "Festivals, fairs, markets, rodeos and community nights. We roll up with the full setup and keep your crowd snacking happy.",
    tilt: "lg:-translate-y-4",
  },
  {
    type: "school",
    icon: GraduationCap,
    title: "School Events",
    img: "/brand/school-event.png",
    imgPos: "!object-[center_30%]",
    alt: "A guest holding a Sy Sy's Snacks box at a school community event",
    copy: "Game days, fundraisers and staff appreciation. An affordable meal that feeds the whole crew without breaking the budget.",
    tilt: "lg:translate-y-6",
  },
  {
    type: "birthday",
    icon: Cake,
    title: "Birthday Parties",
    img: "/brand/birthday-park.png",
    alt: "Friends celebrating outdoors with a Nacho Box and pink lemonade",
    copy: "A nacho bar and ice-cold strawberry lemonade for the birthday crew. Parents love the price, kids devour the rest.",
    tilt: "lg:-translate-y-2",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Events({ onBookType }) {
  return (
    <section id="events" data-testid="events-section" className="relative overflow-hidden bg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-14 max-w-2xl">
          <p className="text-sm font-black uppercase tracking-[0.24em] text-tang">Book us for</p>
          <h2 className="font-display mt-3 text-4xl font-bold sm:text-5xl lg:text-6xl">
            We bring the snacks, <span className="font-logo text-tomato">you bring the crowd</span>
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {EVENTS.map((e, i) => (
            <motion.article
              key={e.type}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.15 }}
              data-testid={`event-card-${e.type}`}
              className={`group flex h-full flex-col overflow-hidden rounded-3xl border-4 border-ink bg-white shadow-pop transition-all duration-300 hover:-translate-y-2 hover:shadow-popLg ${e.tilt}`}
            >
              <div className="relative overflow-hidden border-b-4 border-ink">
                <img
                  src={e.img}
                  alt={e.alt}
                  className={`h-48 w-full object-cover transition-transform duration-500 group-hover:scale-105 ${e.imgPos || ""}`}
                />
                <span className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-xl border-[3px] border-ink bg-sunburst shadow-popSm">
                  <e.icon className="h-5 w-5" strokeWidth={2.75} />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-display text-2xl font-bold uppercase">{e.title}</h3>
                <p className="mt-2 flex-1 text-sm font-semibold leading-relaxed text-ink/75 sm:text-base">
                  {e.copy}
                </p>
                <button
                  type="button"
                  data-testid={`event-book-btn-${e.type}`}
                  onClick={() => onBookType(e.type)}
                  className="mt-5 inline-flex items-center gap-2 self-start rounded-full border-[3px] border-ink bg-tang px-5 py-2.5 text-sm font-black uppercase tracking-wide text-white shadow-popSm transition-all duration-200 hover:-translate-y-0.5 hover:bg-tang-dark"
                >
                  Book this <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" strokeWidth={3} />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
